import '../assets/css/Custom.css';
const Layout = ({children}) => {
    return (
        <>
                <div className="container d-flex justify-content-center ">
                <div className=" pb-sm-4" style={{ width: '100%' }}>
                  {children}
                </div>
            </div>
        </>
    );
};
export default Layout;
